module.exports = __webpack_public_path__ + "static/media/Mexico.5b7a1aa5.jpg";